import { Grid, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import { bgcolor } from "@mui/system";
import moment from "moment";
import { Event } from "react-big-calendar";
import { Link } from "react-router-dom";

type Props = {
  event: Event & {
    color?: string;
    jobId?: string;
    candidateEmail?: string;
  };
};

const HtmlTooltip = styled(({ className, bgColor, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    leaveDelay={500}
    slotProps={{
      tooltip: {
        sx: {
          bgcolor: `${bgColor || "#F1CFFF"} !important`,
        },
      },
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: bgcolor,
    maxWidth: 220,
    border: "1px solid #dadde9",
  },
}));

const InterviewEvent = ({ event }: Props) => {
  const start = moment(event.start);
  const end = moment(event.end);
  return (
    <HtmlTooltip
      bgColor={event.color}
      title={
        <>
          <Typography
            fontSize={"12px"}
            lineHeight={"20px"}
            letterSpacing={"0.1px"}
            fontWeight={"700"}
            align="center"
          >
            {event.title}
          </Typography>
          <Typography
            fontSize={"12px"}
            lineHeight={"20px"}
            letterSpacing={"0.1px"}
            fontWeight={"700"}
            align="center"
          >
            {start.format("hh:mm a")} to {end.format("hh:mm a")}
          </Typography>
          <Link
            to={`/candidates?jobId=${event.jobId}&candidateEmail=${encodeURIComponent(event.candidateEmail || "")}`}
          >
            Go to candidate profile
          </Link>
        </>
      }
    >
      <Grid
        container
        item
        flexDirection={"column"}
        borderRadius={0}
        bgcolor={event.color || "#F1CFFF"}
        gap={0.5}
        p={0.5}
      >
        <Typography
          fontSize={"10px"}
          lineHeight={"20px"}
          fontWeight={700}
          color={"#000"}
        >
          {event.title}
        </Typography>
        <Typography fontSize={"10px"} lineHeight={"20px"} color={"#000"}>
          {start.format("HH:mm a")} - {end.format("HH:mm a")}
        </Typography>
      </Grid>
    </HtmlTooltip>
  );
};

export default InterviewEvent;
